import React from 'react';
import TV from '../images/tv-gray.svg';
import moment from 'moment';
import YouTube from 'react-youtube';
import Skeleton from 'react-loading-skeleton';
import ReactGA from 'react-ga';

const Sidebar = ({selectedVideo, videos}) => {
  let currentVideo;
  let _videoElement;

  if (selectedVideo) {
    currentVideo = videos[selectedVideo];
  }

  const formatTimestamp = timestamp => {
    if (timestamp <= 3659) {
      return String(moment.utc(timestamp * 1000).format('mm:ss'));
    } else {
      return String(moment.utc(timestamp * 1000).format('HH:mm:ss'));
    }
  };

  const initYouTube = e => {
    _videoElement = e.target;
  };

  const trackTimestampClick = timestamp => {
    ReactGA.event({
      category: 'Usage',
      action: 'Clicked Timestamp',
      value: timestamp,
    });
  };

  const jumpToTimestamp = timestamp => {
    if (_videoElement && _videoElement.getPlayerState() === 5) {
      _videoElement.playVideo();
      setTimeout(() => {
        _videoElement.seekTo(timestamp);
      }, 600);
    } else if (_videoElement) {
      _videoElement.seekTo(timestamp);
    }

    trackTimestampClick(timestamp);
  };

  const openInNewWindow = () => {
    ReactGA.event({
      category: 'Usage',
      action: 'Clicked Video Title Link',
      value: currentVideo.name,
    });
    window.open(`https://youtube.com/watch?v=${selectedVideo}`);
  };

  return (
    <div className={`sidebar ${selectedVideo && 'video-selected'}`}>
      {currentVideo && <h3 onClick={openInNewWindow}>{currentVideo.name || <Skeleton/>}</h3>}
      {currentVideo ? (
        <div className='selected-video'>
          <YouTube
            videoId={selectedVideo}
            opts={{
              frameborder: 0,
            }}
            className="video"
            onStateChange={initYouTube}
            onReady={initYouTube}
          />
        </div>
      ) : (
        <div className="placeholder">
          <img src={TV} alt='placeholder' className='placeholder-image'/>
          <p>Nothing selected.</p>
        </div>
      )}
      {currentVideo && (
        <div className='notes'>
          {currentVideo.notes.sort((a, b) => a.timestamp - b.timestamp).map(note => {
            return (
              <div className='note' key={note.id}>
                <span className="note-timestamp" onClick={() => jumpToTimestamp(note.timestamp)}>{formatTimestamp(note.timestamp)}</span>
                <p className="note-content">{note.content}</p>
              </div>
            )
          })}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
